import { getToken, setToken } from '@/utils/helper'
import { setRefer, lsGlobalGet } from '@/utils/ls'
import { resetRouter } from '@/boot/create-router'

// 实现路由身份认证拦截
export default function(Vue, options = {}) {
    var { router, store, config, beforeAuth, afterAuth } = options

    if (!router) {
        throw new Error("必需先创建router实例")
    }

    // 验证前
    router.beforeEach((to, from, next) => {
        if (typeof beforeAuth == "function") {
            beforeAuth(to, from, next, options)
        } else {
            next()
        }
    })

    // 验证中
    router.beforeEach((to, from, next) => {
        // 跳过验证
        if (to.meta && to.meta.auth === false) {
            return next()
        }

        const token = getToken()
        const LOGIN_PAGE_NAME = "login"
        const HOME_NAME = config.homeName
        const meta = to.meta || {}

        function denied() {
            // 清理痕迹
            setToken('')

            // 记录还原信息
            if (to.name !== LOGIN_PAGE_NAME) {
                setRefer(to.path)
            }

            // 要求登录
            next({
                name: LOGIN_PAGE_NAME
            })
        }

        // 无需验证
        if (meta.auth == false) {
            return next()
        }

        if (!token && to.name !== LOGIN_PAGE_NAME) {
            // 未登录且要跳转的页面不是登录页
            denied()
        } else if (!token && to.name === LOGIN_PAGE_NAME) {
            // 未登录且要跳转的页面是登录页
            next()
        } else if (token && to.name === LOGIN_PAGE_NAME) {
            // 已登录且要跳转的页面是登录页
            next({
                name: HOME_NAME
            })
        } else {
            var user = lsGlobalGet('user')
            
            if(user && user.id){
                store.commit('setUserInfo', user)
            }

            if (store.state.user.hasGetUserInfo) {
                next()
            } else {
                store.dispatch('getUserInfo')
                    .then(() => {
                        next()
                    })
                    .catch(error => {
                        console.log(error)
                        // 登录失效
                        denied()
                    })
            }
        }
    })

    // 验证后
    router.afterEach((to) => {
        if (typeof afterAuth == "function") {
            afterAuth(to, options)
        }
    })

    // 重建路由
    store.subscribe((mutation, state) => {
        if (mutation.type == "clearUser") {
            resetRouter(router, {
                routes: config.routes,
                mode: config.routerMode,
                base: config.routerBase,
            })
        }
    })
}
